import React from "react";
import { tWithKeyAttr as t } from "../../../../i18nHelper";
import ActionReportBadge from "../ActionReportBadge/ActionReportBadge";
import styles from "../../appointmentsPage.module.css";

/**
 * Legend for appointment icons - check (שמירת פגישה) and report (מליאת דוח).
 * Shown in calendar header.
 */
const IconsLegend: React.FC = () => {
  return (
    <div className={styles.iconsLegend}>
      <span className={styles.iconsLegendItem}>
        <ActionReportBadge
          variant="check"
          size={14}
          title={t("APPOINTMENTS_ICON_LEGEND_SAVE") || "שמירת פגישה"}
        />
      </span>
      <span className={styles.iconsLegendItem}>
        <ActionReportBadge
          variant="report"
          size={14}
          title={t("APPOINTMENTS_ICON_LEGEND_REPORT") || "מליאת דוח"}
        />
      </span>
    </div>
  );
};

export default IconsLegend;
